import React, { useState } from 'react';
import { IconCollection, OutsideClickHandler, ResponsiveImage, UserBadgeList } from '../../../../components';
import { abbreviateName, formatCreatedAt } from '../../../../util/circleHelper';
import css from './CircleFeedModal.module.css';
import FeedInlineAttachments from '../FeedInlineAttachments';
import FeedDocumentAttachment from '../FeedDocumentAttachment/FeedDocumentAttachment';
import { removeTags } from './CommentContainer';
import { useDispatch, useSelector } from 'react-redux';
import { RenderContent } from '../CircleFeedCard/CircleFeedCard';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { FormattedMessage } from '../../../../util/reactIntl';
import { subscriptionPermissionRequest } from '../../../../ducks/user.duck';
import InReviewCard from '../../../../components/InReviewCard/InReviewCard';
import { deleteReplyFromComment, toggelEditComment } from '../../CircleCommunityPage.duck';

const CommentReplyContainer = props => {
  const { replies, handleLikeDislike, isRequestSpace, onToggleReply, checkCreatePostAuth, postId, spaceId } = props;
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user.currentUser);
  const usersBadgesMap = useSelector(state => state.CircleCommunityPage.usersBadgesMap) || {};
  const usersSubscriptionMap = useSelector(state => state.CircleCommunityPage.usersSubscriptionMap) || {};
  const usersStripeConnectionMap = useSelector(state => state.CircleCommunityPage.usersStripeConnectionMap) || {};
  const [isOpen, setIsOpen] = useState(false);
  const {
    body_text,
    is_liked,
    author,
    created_at,
    user_likes_count,
    id: commentId,
    replies_count,
    tiptap_body,
    parent_comment_id,
    flagged_for_approval_at = null,
  } = replies || {};
  const { content = [] } = tiptap_body?.body || {};
  const { name, roles, headline, avatar_url, community_member_id } = author || {};

  // Check if current user is the author of this reply
  const isOwnReply = headline && currentUser?.id?.uuid && headline === currentUser?.id?.uuid;

  const handleDeleteReply = () => {
    if (!parent_comment_id || !commentId || !spaceId) {
      console.error('[CommentReplyContainer] Missing required params:', { 
        parent_comment_id, 
        commentId, 
        spaceId 
      });
      return;
    }
    
    console.log('[CommentReplyContainer] Deleting reply:', { 
      parent_comment_id, 
      replyId: commentId, 
      spaceId, 
      userId: currentUser?.id?.uuid
    });
    
    // Delete reply using the correct API endpoint for nested replies
    dispatch(deleteReplyFromComment(parent_comment_id, commentId, spaceId, currentUser?.id?.uuid));
    setIsOpen(false);
  };

  const handleEditReply = () => {
    dispatch(toggelEditComment(replies));
    setIsOpen(false);
  };

  const handleToggleReply = () => {
    if (!checkCreatePostAuth) {
      dispatch(subscriptionPermissionRequest(true));
      return;
    }
    onToggleReply(replies);
  };

  return (
    <div className={css.commentInComments}>
      <div className={css.commentFeedsWrapper}>
        {' '}
        <div className={css.imageWrapper}>
          {avatar_url ? (
            <ResponsiveImage imagewithURL={avatar_url} />
          ) : (
            <div className={css.nameWrapper}>{abbreviateName(name)}</div>
          )}
          {headline && usersStripeConnectionMap[headline] ? (
            <div className={css.verfiedIcon}>
              {' '}
              <IconCollection name="profile_badge_stripe" />{' '}
            </div>
          ) : headline && usersSubscriptionMap[headline] ? (
            <div className={css.verfiedIcon}>
              {' '}
              <IconCollection name="profile_badge_elephant" />{' '}
            </div>
          ) : null}
        </div>
        <div className={css.nameDetails}>
          <div className={css.nameText}>
            <div className={`${css.nameTopRow} ${css.replyNameTopRow}`}>
              <span className={`${css.authorName} ${css.replyAuthorName}`}>{name}</span>{' '}
              {flagged_for_approval_at ? (
                <span className={css.reviewText}>
                  <InReviewCard />{' '}
                </span>
              ) : null}{' '}
              {headline && usersBadgesMap[headline] && usersBadgesMap[headline].length > 0 && (
                <div className={`${css.userbagdeComment} ${css.replyUserBadge}`}>
                  {' '}
                  <UserBadgeList badges={usersBadgesMap[headline]} size="small" />
                </div>
              )}
              <b>{formatCreatedAt(created_at)}</b>
            </div>

            {currentUser && isOwnReply ? (
              <div className={css.dropdownDots}>
                <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
                  <span onClick={() => setIsOpen(!isOpen)} className={css.iconWrapper}>
                    <ProfileIconCard type="dot" />
                  </span>
                  {isOpen ? (
                    <div className={css.dropdownMenu}>
                      <ul>
                        <li onClick={handleEditReply}>
                          <FormattedMessage id="CircleFeedPage.editComment" />
                        </li>
                        <li onClick={handleDeleteReply}>
                          <FormattedMessage id="CircleFeedPage.deleteComment" />
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </OutsideClickHandler>
              </div>
            ) : null}
          </div>

          <RenderContent
            content={content}
            sgids_to_object_map={tiptap_body?.sgids_to_object_map}
            dispatch={dispatch}
          />
          {/* {body_text ? <div className={css.detailsText}>{removeTags(body_text)}</div> : null} */}
          <div className={css.likedSection}>
            <div className={css.likeReplySection}>
              <div onClick={() => handleLikeDislike(commentId, is_liked)}>
                {is_liked ? (
                  <span className={css.likedText}>Liked</span>
                ) : (
                  <span className={css.likeText}>Like</span>
                )}{' '}
              </div>
              <span className={css.replyText} onClick={handleToggleReply}>
                Reply
              </span>
            </div>
            <div className={css.likeCount}>{user_likes_count} like</div>
          </div>
        </div>
      </div>

      <div className={css.inlineAttachments}>
        <FeedInlineAttachments
          inline_attachments={tiptap_body?.inline_attachments}
          attachments={tiptap_body?.attachments}
          isRequestSpace={isRequestSpace}
        />
      </div>
      {/* show documents */}
      <FeedDocumentAttachment
        inline_attachments={tiptap_body?.inline_attachments}
        attachments={tiptap_body?.attachments}
      />
    </div>
  );
};

export default CommentReplyContainer;
